import { render, staticRenderFns } from "./FullCarouselImg.vue?vue&type=template&id=5b1e8fdf"
import script from "./FullCarouselImg.vue?vue&type=script&lang=js"
export * from "./FullCarouselImg.vue?vue&type=script&lang=js"
import style0 from "./FullCarouselImg.vue?vue&type=style&index=0&id=5b1e8fdf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports